import { ArrowRight } from "lucide-react";
import Container from "@/components/ui/Container";
import Button from "@/components/ui/Button";
import Reveal from "@/components/common/Reveal";

export default function CTA() {
  return (
    <section className="py-20 sm:py-28">
      <Container>
        <Reveal>
          <div className="relative overflow-hidden rounded-3xl bg-gradient-to-br from-brand-600 via-brand-600 to-violet-700 px-8 py-16 text-center shadow-glow sm:px-16">
            {/* decorative rings */}
            <div className="pointer-events-none absolute -left-16 -top-16 h-64 w-64 rounded-full bg-white/10 blur-2xl" />
            <div className="pointer-events-none absolute -bottom-20 -right-10 h-72 w-72 rounded-full bg-fuchsia-400/20 blur-3xl" />

            <h2 className="relative mx-auto max-w-2xl font-display text-3xl font-bold tracking-tight text-white sm:text-4xl">
              Ship with confidence. Test in plain English.
            </h2>
            <p className="relative mx-auto mt-4 max-w-xl text-brand-100">
              Start free in minutes. No credit card, no scripts to maintain.
            </p>
            <div className="relative mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
              <Button size="lg" variant="onbrand" to="/signup">
                Get started free
                <ArrowRight size={18} />
              </Button>
              <Button size="lg" variant="onbrandGhost" to="/extension">
                Explore the extension demo
              </Button>
            </div>
          </div>
        </Reveal>
      </Container>
    </section>
  );
}
